'use strict';

module.exports = require('./lib/extend');



//////////////////
// WEBPACK FOOTER
// ./~/node.extend/index.js
// module id = 2690
// module chunks = 2